<template>
	<div class="login mh-700">
		<v-container fluid>
			<v-layout row>
				<v-flex xs12>
					<div class="page-heading">
						<v-layout row wrap>
							<v-flex xs12 md10>
								<div class="heading-text">
									<h2>{{ subtitle }}</h2>
								</div>
							</v-flex>
						</v-layout>
					</div>
				</v-flex>
			</v-layout>
			<v-layout row class="padded">
				<v-flex xs12>
					<v-tabs
						v-model="tab"
						background-color="white gray"
						color="accent"
						:right="true"
					>
						<v-tabs-slider></v-tabs-slider>

						<v-tab @click="loadUsers()">Users</v-tab>
						<v-tab-item>
							<v-data-table
								:headers="userHeaders"
								:items="users"
								:items-per-page="25"
								class="elevation-1"
								loading="dataLoading"
								loading-text="Loading... Please wait"
							>
								<template v-slot:item.registered="{ item }">
									<v-simple-checkbox
										v-model="item.registered"
										disabled
									></v-simple-checkbox>
								</template>
								<template v-slot:item.abstract="{ item }">
									<v-simple-checkbox
										v-model="item.abstract"
										disabled
									></v-simple-checkbox>
								</template>
							</v-data-table>
						</v-tab-item>

						<v-tab @click="loadAbstracts()">Abstracts</v-tab>
						<v-tab-item>
							<v-data-table
								:headers="abstractHeaders"
								:items="abstracts"
								:items-per-page="25"
								class="elevation-1"
								loading="dataLoading"
								loading-text="Loading... Please wait"
							></v-data-table>
						</v-tab-item>

						<v-tab @click="loadOrders()">Orders</v-tab>
						<v-tab-item>
							<v-data-table
								:headers="orderHeaders"
								:items="orders"
								:items-per-page="25"
								class="elevation-1 orders-table"
								loading="dataLoading"
								loading-text="Loading... Please wait"
							></v-data-table>
						</v-tab-item>

						<v-tab @click="loadUsers()">Change Role</v-tab>
						<v-tab-item>
							<v-card>
								<v-card-text>
									<v-autocomplete
										v-model="selectedUser"
										:items="users"
										:filter="userFilter"
										item-text="email"
										item-value="email"
										hint="Select User"
										required
									></v-autocomplete>
									<v-btn
										@click="
											submitAdminRequest(selectedUser)
										"
										>Grant Admin</v-btn
									>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab @click="loadAbstracts()">Download Abstracts</v-tab>
						<v-tab-item>
							<v-card>
								<v-card-text>
									<v-btn
										@click="
											downloadAbstractsAsCsv()
										"
										>Download</v-btn
									>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab @click="loadUsers()">Download Users</v-tab>
						<v-tab-item>
							<v-card>
								<v-card-text>
									<v-btn
										@click="
											downloadUsersAsCsv()
										"
										>Download</v-btn
									>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab @click="loadUsers()">Download Orders</v-tab>
						<v-tab-item>
							<v-card>
								<v-card-text>
									<v-btn
										@click="
											downloadOrdersAsCsv()
										"
										>Download</v-btn
									>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</v-tabs>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
import Logger from '@/services/Logger';
import Users from '@/services/Users';
import Abstracts from '@/services/Abstracts';
import Orders from '@/services/Orders';
export default {
	name: 'Admin',
	data: function() {
		return {
			subtitle: 'Administration',
			tab: '1',
			logHeaders: [
				{
					text: 'Time',
					align: 'start',
					sortable: true,
					value: 'time'
				},
				{ text: 'Level', value: 'level', sortable: true },
				{ text: 'Message', value: 'message' },
				{ text: 'Data', value: 'data' }
			],
			userHeaders: [
				{
					text: 'Last Name',
					align: 'start',
					sortable: true,
					value: 'lastName'
				},
				{
					text: 'First Name',
					value: 'firstName',
					sortable: true
				},
				{ text: 'Email', value: 'email' },
				{ text: 'Honorific', value: 'honorific' },
				{ text: 'Gender', value: 'gender' },
				{ text: 'Institution', value: 'institution' },
				{ text: 'Dietary', value: 'dietaryRestriction'},
				{ text: 'Abstract?', value: 'abstract' },
				{ text: 'Registered?', value: 'registered' }
			],
			abstractHeaders: [
				{
					text: 'Authors',
					align: 'start',
					sortable: true,
					value: 'authors'
				},
				{ text: 'Category', value: 'category', sortable: true },
				{ text: 'Title', value: 'title', sortable: true },
				{ text: 'Stipend?', value: 'stipend' },
				{ text: 'Abstract', value: 'abstract' }
			],
			orderHeaders: [
				{ text: 'First Name', value: 'firstName' },
				{ text: 'Last Name', value: 'lastName', sortable: true },
				{ text: 'Order Id', value: 'orderId' },
				{ text: 'Created DateTime', value: 'timeStamp', sortable: true },
				{ text: 'Items', value: 'items' },
				{ text: 'Total', value: 'total' }
			],
			dataLoading: true,
			users: [],
			abstracts: [],
			orders: [],
			selectedUser: null
		};
	},
	methods: {
		loadUsers: function() {
			var parent = this;
			parent.users = [];
			Users.getUsers()
				.once('value')
				.then(function(snapshot) {
					snapshot.forEach(data => {
						parent.users.push({
							id: data.val().id,
							abstract: data.val().abstract,
							city: data.val().city,
							country: data.val().country,
							email: data.val().email,
							firstName: data.val().firstName,
							gender: data.val().gender,
							honorific: data.val().honorific,
							institution: data.val().institution,
							position: data.val().position,
							lastName: data.val().lastName,
							registered: data.val().registered,
							role: data.val().role,
							stateProvince: data.val().stateProvince,
							streetAddress: data.val().streetAddress,
							dietaryRestriction: data.val().dietaryRestriction
						});
					});
					parent.dataLoading = false;
				});
		},
		loadAbstracts: function() {
			var parent = this;
			parent.abstracts = [];
			Abstracts.getAbstracts()
				.once('value')
				.then(function(snapshot) {
					snapshot.forEach(data => {
						parent.abstracts.push({
							abstract: data.val().abstract,
							authors: data.val().authors,
							category: data.val().category,
							stipend: data.val().stipend,
							title: data.val().title
						});
					});
					parent.dataLoading = false;
				});
		},
		loadOrders: function() {
			var parent = this;
			parent.loadUsers();
			parent.orders = [];
			Orders.getOrders()
				.once('value')
				.then(function(snapshot) {
					snapshot.forEach(data => {
						var orderUser = parent.users.filter(u => u.id == data.val().userId)[0];
						var formattedItems = '';
						data.val().items.forEach((item) => {
							formattedItems = formattedItems.concat(item.item + ' x ' + item.quantity + ' = ' + item.itemTotal + '\n');
						});
						parent.orders.push({ 
							orderId: data.val().orderId,
							timeStamp: data.val().timeStamp ? data.val().timeStamp : 'Sep 4, 2022, 12:00 AM',
							total: data.val().total,
							firstName: orderUser ? orderUser.firstName : '',
							lastName: orderUser ? orderUser.lastName : '',
							items: formattedItems
						});
					});
					parent.dataLoading = false;
				});
		},
		userFilter(item, queryText) {
			const user = item.email.toLowerCase();
			const searchText = queryText.toLowerCase();

			return user.indexOf(searchText) > -1;
		},
		submitAdminRequest(userId) {
			Users.makeAdmin(userId);
		},
		downloadAbstractsAsCsv() {
			var parent = this;
			parent.loadUsers();
			var abstractList = [];
			Abstracts.getAbstracts()
				.once('value')
				.then(function(snapshot) {
					snapshot.forEach(data => {
						console.dir(data.val());
						var abstractUser = parent.users.filter(u => u.id == data.val().userid)[0];
						console.dir(abstractUser);
						abstractList.push({
							userNameLast: abstractUser ? abstractUser.lastName : '',
							userNameFirst: abstractUser ? abstractUser.firstName : '',
							userPosition: abstractUser ? abstractUser.position : '',
							authors: data.val().authors,
							title: data.val().title,
							category: data.val().category,
							stipend: data.val().stipend,
							abstract: "\"" + data.val().abstract + "\""
						})
					});
					const csvString = [
					[
						"UserNameLast",
						"UserNameFirst",
						"UserPosition",
						"Authors",
						"Title",
						"Category",
						"Stipend",
						"Abstract"
					],
					...abstractList.map(a => [
						a.userNameLast,
						a.userNameFirst,
						a.userPosition,
						a.authors,
						a.title,
						a.category,
						a.stipend,
						a.abstract
					])
				]
				.map(e => e.join("\t")) 
				.join("\r\n");

				var a = document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([csvString], {type: "text/plain"}));
				a.download = 'abstracts.txt';
				a.click();
			});			
		},
		downloadUsersAsCsv() {
			var userList = [];
			Users.getUsers()
				.once('value')
				.then(function(snapshot) {
					snapshot.forEach(data => {
						userList.push({
							city: data.val().city,
							country: data.val().country,
							email: data.val().email,
							firstName: data.val().firstName,
							institution: data.val().institution,
							lastName: data.val().lastName,
							dietaryRestriction: data.val().dietaryRestriction,
							registered: data.val().registered
						});
					});
					const csvString = [
					[
						"Last Name",
						"First Name",
						"Institution",
						"City",
						"Country",
						"Email",
						"Dietary Restriction",
						"Registered?"
					],
					...userList.map(a => [
						a.lastName,
						a.firstName,
						a.institution,
						a.city,
						a.country,
						a.email,
						a.dietaryRestriction,
						a.registered
					])
				]
				.map(e => e.join("\t")) 
				.join("\r\n");

				var a = document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([csvString], {type: "text/plain"}));
				a.download = 'participants.txt';
				a.click();
			});
		},
		downloadOrdersAsCsv() {
			var parent = this;
			var orderList = [];
			Orders.getOrders()
				.once('value')
				.then(function(snapshot) {
					snapshot.forEach(data => {
						var orderUser = parent.users.filter(u => u.id == data.val().userId)[0];
						var registration = !!data.val().items && data.val().items.filter(i => i.item.includes('Registration')).length > 0 ? data.val().items.filter(i => i.item.includes('Registration'))[0].item : '';
						var sgodQty = !!data.val().items && data.val().items.filter(i => i.item.includes('Opening Dinner')).length > 0 ? data.val().items.filter(i => i.item.includes('Opening Dinner'))[0].quantity : '';
						var sgcdQty = !!data.val().items && data.val().items.filter(i => i.item.includes('Closing Dinner')).length > 0 ? data.val().items.filter(i => i.item.includes('Closing Dinner'))[0].quantity : '';
						var sgexQty = !!data.val().items && data.val().items.filter(i => i.item.includes('Excursion')).length > 0 ? data.val().items.filter(i => i.item.includes('Excursion'))[0].quantity : '';
						orderList.push({
							orderId: data.val().orderId,
							timeStamp: data.val().timeStamp ? data.val().timeStamp : 'Sep 4, 2022, 12:00 AM',
							total: data.val().total,
							firstName: orderUser ? orderUser.firstName : '',
							lastName: orderUser ? orderUser.lastName : '',
							position: orderUser ? orderUser.position : '',
							registration: registration,
							socialGuestOpeningDinner: sgodQty,
							socialGuestClosingDinner: sgcdQty,
							socialGuestExcursion: sgexQty
						});
					});
					const csvString = [
					[
						"Order Id",
						"TimeStamp",
						"Total",
						"First Name",
						"Last Name",
						"Position",
						"Registration",
						"Social Guest Opening Dinner",
						"Social Guest Closing Dinner",
						"Social Guest Excursion"
					],
					...orderList.map(a => [
						a.orderId,
						a.timeStamp,
						a.total,
						a.firstName,
						a.lastName,
						a.position,
						a.registration,
						a.socialGuestOpeningDinner,
						a.socialGuestClosingDinner,
						a.socialGuestExcursion
					])
				]
				.map(e => e.join("\t")) 
				.join("\r\n");

				var a = document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([csvString], {type: "text/plain"}));
				a.download = 'orders.txt';
				a.click();
			});
		}
	}
};
</script>
<style src="@/style.css"></style>
